import { AlertIcon } from '@/app/icons/AlertIcon';
import { GreenInfoIcon } from '@/app/icons/GreenInfoIcon';
import { Grid, Typography } from '@mui/material';
import { InfoIcon } from '@/app/icons/InfoIcon';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import React, { FC, PropsWithChildren } from 'react';

interface Props {
  error?: boolean;
  isWarn?: boolean;
  sx?: SxProps<Theme>;
}

export const LetterAlert: FC<PropsWithChildren<Props>> = (props: PropsWithChildren<Props>) => {
  const { children, sx, error, isWarn } = props;
  return (
    <Grid
      container={true}
      alignItems={'center'}
      sx={{
        padding: '12px 16px',
        borderRadius: '6px',
        ...sx,
        background: (theme: Theme) =>
          error ? theme.colors.redBackground : isWarn ? theme.colors.alert : theme.colors.lightGreenBackground,
        color: (theme: Theme) => (error ? theme.colors.red : isWarn ? theme.colors.textColor : theme.colors.green),
      }}>
      <Grid item={true} mr={1}>
        {error ? (
          <AlertIcon sx={{ display: 'block' }} />
        ) : isWarn ? (
          <InfoIcon sx={{ display: 'block' }} />
        ) : (
          <GreenInfoIcon sx={{ display: 'block' }} />
        )}
      </Grid>
      <Grid item={true} xs={true}>
        <Typography variant={sx ? 'inherit' : 'body1'} component={'div'}>
          {children}
        </Typography>
      </Grid>
    </Grid>
  );
};
